export const ProductTaxExonerationComponent = {
  templateUrl:
    './app/ajs/_shared/components/product-tax-exoneration/product-tax-exoneration.component.html',
  bindings: {
    item: '<',
    tax: '<',
    productType: '<', // product category / product
    productId: '<', // product category / product
    mode: '<',
    onTaxExonerationSaved: '&',
    onTaxExonerationCanceled: '&',
  },
  controller: ProductTaxExonerationController,
  controllerAs: 'vm',
};

ProductTaxExonerationController.$inject = [
  'UtilService',
  'SessionService',
  'moment',
  'ProductService',

  // Angular downgraded service
  'countryService',
];

function ProductTaxExonerationController(
  UtilService,
  SessionService,
  moment,
  ProductService,

  // Angular downgraded service
  countryService
) {
  const vm = this;

  // public properties
  // -----------------------
  vm.UtilService = new UtilService(vm);

  vm.todayTaxRate = null;

  // private properties
  // -----------------------
  let company = SessionService.getSelectedAccountCompany();

  let userLanguageCode = SessionService.getUserLanguage().code;
  vm.dateDisplay = userLanguageCode !== 'es' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';
  // vm.dateDisplay = config.DATE_DISPLAY;

  vm.$onInit = function () {
    if (vm.item.id) {
      // view / edit
      setItemOptions(vm.item, vm.mode);
    } else {
      // new
      vm.createMode = true;

      vm.item = {
        tax_id: vm.tax.id,
        date: '',
      };
    }

    // Initializers
    setDateOptions();
    todayTaxRate(vm.tax);
    getExonerationTypes(company.country.code);
  };

  // public methods
  // -----------------------
  vm.editProductTaxExoneration = function () {
    vm.editMode = true;
    vm.viewMode = false;
  };

  // Create/Update
  vm.saveProductTaxExoneration = function (isFormValid) {
    // vm.formErrors = false; // only if btn is not disabled

    if (!isFormValid) {
      vm.serverErrors = [];
      return;
    }

    // console.log(vm.item);
    // return;

    vm.sendingForm = true;
    ProductService.saveProductTaxExoneration(vm.item, vm.productType, vm.productId).then(function (
      data
    ) {
      // , vm.productId
      if (!data.errors) {
        vm.onTaxExonerationSaved({ item: data });
      } else {
        vm.serverErrors = vm.UtilService._showItemServerErrors(data.errors);
      }

      vm.sendingForm = false;
    });
  };

  vm.cancel = function () {
    vm.onTaxExonerationCanceled();
  };

  // private methods
  // -----------------------
  function setItemOptions(item, mode) {
    vm.createMode = false;
    vm.editMode = false;
    vm.viewMode = true;

    if (mode === 'edit') {
      vm.editProductTaxExoneration();
    }

    item.date = moment(item.date);
  }

  function setDateOptions() {
    let onChangeDate = () => {};

    vm.dateOptions = vm.UtilService.singleDatePickerOptions({
      minDate: moment().subtract(3, 'years'),
      maxDate: moment(),
      showDropdowns: true,
      dateDisplay: vm.dateDisplay,
      onChangeDate: onChangeDate,
    });
  }

  function todayTaxRate(tax) {
    if (!tax.tax_rates) return;

    vm.todayTaxRate = tax.tax_rates.find((tax_rate) => {
      return moment().isBetween(moment(tax_rate.from), moment(tax_rate.to).add(1, 'days'));
    });
  }

  function getExonerationTypes(code) {
    let params = {
      country_code: code.toLowerCase(),
      skip_check_role: true,
      lang: userLanguageCode,
    };

    vm.loadingExonerationTypes = true;
    countryService.getExonerationTypesByCountry(params).subscribe((response) => {
      vm.exonerationTypes = response;

      // console.log(vm.exonerationTypes);

      if (!vm.createMode) {
        vm.exonerationType = response.find((item) => item.code === vm.item.exoneration_type_code);
      }

      vm.loadingExonerationTypes = false;
    });
  }
}
